<template>
  <div>
    <el-row>
      <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round
          @click="openDialog(null)">添加</el-button></el-col>
    </el-row>

    <el-table :data="newsData" style="border: none;min-height: 400px;">

      <el-table-column prop="title" label="标题" width="140">
      </el-table-column>
      <el-table-column prop="summary" label="简介" width="120">
      </el-table-column>
      <el-table-column label="详情">
        <template #default="scope">
          <div v-html="scope.row.content" style="max-height: 60px;"></div>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="录入日期">
      </el-table-column>
      <el-table-column prop="typeName" label="类型">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">

          <el-row>
            <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="openDialog(scope.row)"></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" circle
              @click="deleteProduct(scope.row.id)"></el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="60%">
      <el-form :model="currentRow">
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-input placeholder="请输入标题" v-model="currentRow.title" style="display: inline;margin-left: 5px; " clearable
            required>
          </el-input>
        </el-form-item>

        <el-form-item label="概述" :label-width="formLabelWidth">
          <el-input placeholder="请输入概述" v-model="currentRow.summary" style="display: inline;margin-left: 5px; "
            clearable required>
          </el-input>
        </el-form-item>
        <el-form-item label="详情" :label-width="formLabelWidth">
          <!-- <el-input placeholder="请输入详情" v-model="currentRow.content" style="display: inline;margin-left: 5px; height: 200px;" 
                        clearable required>
                        </el-input> -->
          <!-- <vue-editor v-model="currentRow.content" :options="editorOptions" ></vue-editor> -->
          <ckeditor v-model="currentRow.content" :config="editorConfig"></ckeditor>
        </el-form-item>

        <el-form-item label="类型" :label-width="formLabelWidth">
          <DropDownTree :data="typeList" :defaultProps="dropProps" :selectValue="currentRow.typeID" ref="typeTree"
            @update:selectID="typeSelectValueChange" style="margin-left: 5px; width: 235px;"></DropDownTree>
        </el-form-item>
        <el-form-item label="文件" :label-width="formLabelWidth">
          <el-upload class="avatar-uploader" :before-upload="beforeUpload" action="" :show-file-list="false"
            :on-change="handleFileChange" :file-list="fileList">
            <img v-if="isImage" :src="currentRow.url" class="avatar" />
            <video v-else-if="isVideo" :src="currentRow.url" controls class="avatar">
              Your browser does not support the video tag.
            </video>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveInfo">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>

  import { submitDataInfo, getDataInfo, getVlogType } from "@/api/rbac/vlog";
  import DropDownTree from '../../../src/components/common/DropDownTree.vue';
  // import { VueEditor} from "vue2-editor";
  export default {
    components: {
      DropDownTree,
      // VueEditor,
    },
    data() {
      return {
        dialogVisible: false,

        newsData: [],
        currentRow: { id: 0, title: '', summary: '', content: '', url: '', typeID: 0 },
        formLabelWidth: '120px',
        fileList: [],
        typeList: [],
        dropProps: {
          children: "children",
          label: "name",
        },
        isImage: false,
        isVideo: false,
        isFirstOpen: true,
        editorConfig: {
          extraPlugins: 'font,colorbutton', // 添加字体和颜色插件
          toolbar: [
            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
            { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
            { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
            { name: 'colors', items: ['TextColor', 'BGColor'] },
            // { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 视频功能
            { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 添加图片按钮
            { name: 'links', items: ['Link', 'Unlink'] },
          ],
          font_names: 'Arial/Arial, Helvetica, sans-serif;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif',
          fontSize_sizes: '9/9px;11/11px;13/13px;16/16px;18/18px;21/21px;24/24px;28/28px;32/32px',
          language: 'zh-cn'
        },
      }
    },
    created() {
      this.loadDataList();
      this.getTypeList();
    },
    methods: {
      async loadDataList() {
        try {
          getDataInfo({ strType: 'vlog' }).then(res => {
            if (res.data.length == 0) {
              // console.log(this.dataList)
            }
            else {
              this.newsData = res.data;
              this.newsData.forEach(comNew => {
                comNew.url = "../../../assets/img/Vlog/" + comNew.url;
              });
            }
          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
      rowClick(item) {
        this.currentRow = { ...item }
      },
      //获取类型
      async getTypeList() {
        try {
          getVlogType().then((res) => {
            if (res.data.length == 0) {
              console.log("无零件类型")
            }
            else {
              // const listTree=arrayToTree(res.data)
              // this.listType=listTree;
              // this.listType=[{id:1,name:'根节点1',children:[{id:2,name:'节点1'},{id:3,name:'节点2'},]},{id:4,name:'根节点2',children:[{id:5,name:'节点3'},]}]
              this.typeList = res.data;
            }
          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },

      // 类型改变
      async typeSelectValueChange(value) {
        // console.log(value)
        this.currentRow.typeID = value;
        // this.popData.typeName=value;
      },
      openDialog(item) {
        this.dialogVisible = true

        // 深拷贝避免直接修改原数据
        if (item) {
          this.currentRow = { ...item }
          const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
          const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'mkv', ''];
          const extension = this.currentRow.url.split('.').pop().toLowerCase();
          if (imageExtensions.includes(extension)) {
            this.isImage = true;
            this.isVideo = false;
          }
          if (videoExtensions.includes(extension)) {
            this.isImage = false;
            this.isVideo = true;
          }
        } else {
          this.currentRow = { id: 0, title: '', summary: '', content: '', url: '', typeID: 0 };
        }
        if (this.isFirstOpen) {
          this.checkInterval = setInterval(() => {
            const dynamicDivs = document.querySelectorAll('.cke_notifications_area');

            if (dynamicDivs.length > 0) {
              dynamicDivs.forEach((div) => {
                div.style.display = 'none'
              });
              clearInterval(this.checkInterval); // 停止轮询
              this.isFirstOpen = false;
              // 可以在这里执行加载后的操作
              // 如果只需要检查一次，可以调用 clearInterval(this.checkInterval);
            }
          }, 100); // 每 500ms 检查一次
        }
      },
      beforeUpload(file) {
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
        if (isImage) {
          this.isImage = true;
          this.isVideo = false;
        } else if (isVideo) {
          this.isVideo = true;
          this.isImage = false;
        }
        return false; // 阻止自动上传
      },
      handleFileChange(file, fileList) {
        console.log('thisfileList', this.fileList)
        console.log('fileList', fileList)
        this.fileList = [];
        this.fileList.push(file)
        if (file.status === 'ready') {
          // 当文件状态为 ready 时，生成预览 URL
          const reader = new FileReader();
          reader.onload = (e) => {
            this.currentRow.url = e.target.result;
          };
          reader.readAsDataURL(file.raw);
        }
      },

      saveInfo() {
        if (!String(this.currentRow.title).trim()) {
          return alert("请填写标题")
        }
        if (!String(this.currentRow.summary).trim()) {
          return alert("请填写概述")
        }
        if (!String(this.currentRow.content).trim()) {
          return alert("请填写详情")
        }
        if (this.fileList.length == 0 && this.currentRow.id == 0) {
          return alert("请选择文件")
        }
        const formData = new FormData();
        this.fileList.forEach((file) => {
          formData.append('files[]', file.raw);
          console.log(file);
        });
        formData.append("strType", "vlog")
        formData.append("ID", this.currentRow.id)
        formData.append("title", this.currentRow.title)
        formData.append("typeID", this.currentRow.typeID)
        formData.append("content", this.currentRow.content)
        formData.append("monthDay", this.currentRow.monthDay)
        formData.append("summary", this.currentRow.summary)
        try {
          submitDataInfo(formData).then(res => {
            if (res.length == 0) {
              alert('失败');
            }
            else {
              alert('成功');
              this.dialogVisible = false;
              this.currentRow = { id: 0, title: '', summary: '', content: '', url: '', typeID: 0 };
              this.loadDataList();

            }
          })
        } catch (error) {
          alert('未成功');
        }
      },

    }
  }
</script>
<style scoped>
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
  }

  .avatar-uploader:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>